import React, { PropTypes } from 'react';
import { Link, withRouter } from 'react-router';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BorrowingList from '../../shared/BorrowingList';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import Checkbox from '@bibliocommons/base-checkbox';
import { Table } from '@bibliocommons/base-table';
import BatchActionsControls from '../../../shared/BatchActions/BatchActionsControls';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import ProgressBar from '@bibliocommons/shared-progress-bar';
import './Fines.scss';
import { Generic } from '@bibliocommons/shared-messages';
import MessagingContainer from '../../../../containers/shared/Messaging/MessagingContainer';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import FinesUtilityBar from '../FinesUtilityBar/FinesUtilityBar';
import Pagination from '@bibliocommons/pagination';
import DollarAmount from '../../shared/DollarAmount';
import BorrowingHeader from '../../shared/BorrowingHeader';
import FinesEmptyContentPanel from '../FinesEmptyContentPanel';
import BatchActionsToolbar from '../../../shared/BatchActions/BatchActionsToolbar';
import { DropdownMenuItem } from '@bibliocommons/base-dropdown';
import BatchActionLink from '../../../shared/BatchActions/BatchActionLink';
import FineStatusCapsule from '../FineStatusCapsule';
import FineDateFields from '../FineDateFields';

const fineIsPayable = (fine) =>
  fine.get('status').includes('UNPAID') && !fine.get('accruing') && !fine.get('credit');

// TODO: BCRest will be updated to return 'CREDIT', 'ACCRUING', 'PAID', or 'UNPAID' for the status
// in CORE-51497. Currently the status is 'UNPAID' for credit and accruing fines.
const getFineStatus = (fine) =>
  (fine.get('credit') && 'CREDIT') ||
  (fine.get('accruing') && 'ACCRUING') ||
  fine.get('status');

const renderAmountAndStatus = (value, index, fine) => {
  const status = getFineStatus(fine);
  const dollarAmount = <DollarAmount amount={value} />;

  return (
    <div className="fine-amount-and-status">
      {dollarAmount}
      {status !== 'UNPAID' && <div className="fine-status"><FineStatusCapsule status={status} /></div>}
    </div>
  );
};

class Fines extends BcReactComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedItems: Immutable.Map(),
      showEmptyFineError: false
    };

    this.bindAll('handleSort', 'renderFinesCheckbox', 'toggleFineSelection', 'selectAll', 'payAll', 'createMarkup', 'postToFinesGateway', 'paySelected', 'getSortOptions', 'handleSort', 'updatePage', 'refreshTable', 'renderBatchActionsMenu', 'renderBatchActionsToolbar');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.paymentForm && (nextProps.paymentForm !== this.props.paymentForm)) {
      setTimeout(() => {
        document.getElementById('checkout').submit();
      }, 0);
    }

    const pageChanged = nextProps.currentPage !== this.props.currentPage;
    const sortChanged = nextProps.location.query.sort !== this.props.location.query.sort;
    if (pageChanged || sortChanged) {
      this.props.FinesActions.updatePage({
        ...location.query,
        page: nextProps.currentPage,
        sort: nextProps.location.query.sort,
        accountId: this.props.account.get('id')
      });
    }
  }

  selectAll(selected) {
    if (selected) {
      this.setState({
        selectedItems: this.props.fines
          .filter(fine => fineIsPayable(fine))
          .map(fine => fine.get('id'))
          .reduce((result, item) => result.set(item, item), Immutable.Map())
      });
    } else {
      this.setState({
        selectedItems: Immutable.Map()
      });
    }
  }

  toggleFineSelection(e, { value: id }) {
    const isSelected = this.state.selectedItems.has(id);
    if (isSelected) {
      return this.setState({
        selectedItems: this.state.selectedItems.deleteIn([id])
      });
    }

    return this.setState({
      selectedItems: this.state.selectedItems.set(id)
    });
  }

  renderFinesCheckbox(value, index, fine) {
    const payable = fineIsPayable(fine);

    return (
      <Checkbox
        id={`item_${value}`}
        handleChange={this.toggleFineSelection}
        name="items[]"
        disabled={!payable}
        checked={this.state.selectedItems.has(value)}
        value={value}
        label={<FormattedMessage id="batch_actions_checkbox" />}
        srOnlyLabel
        inline />
    );
  }

  postToFinesGateway(query) {
    this.props.FinesActions.fetchFinesPaymentForm(query);
  }

  payAll() {
    this.postToFinesGateway({ payAll: 1 });
  }

  paySelected() {
    const items = [];
    if (this.state.selectedItems.size === 0) {
      this.setState({ showEmptyFineError: true });
    } else {
      this.state.selectedItems.forEach((k, v) => {
        items.push(`${v}`);
      });
      this.postToFinesGateway({ items });
    }
  }

  createMarkup() {
    return { __html: this.props.paymentForm };
  }

  getUrlWithPatronInfo(url) {
    let newUrl = url.replace('{patronID}', this.props.user.get('id'));
    newUrl = newUrl.replace('{barcode}', this.props.account.get('barcode'));
    return newUrl;
  }

  renderFinesPaymentButtons() {
    const finesSettings = this.props.onlineFinesPayment;
    const popup = finesSettings.get('popup');
    return (
      <div className="cp-fines-buttons">
        {finesSettings.get('message') &&
          <div className="col-sm-7">
            {finesSettings.get('message')}
          </div>
        }
        <div className={finesSettings.get('message') ? 'col-sm-5' : 'col-sm-12'}>
          {finesSettings.get('url') &&
            <Link to={this.getUrlWithPatronInfo(finesSettings.get('url'))} target={popup ? '_blank' : '_self'} className="btn cp-primary-btn btn-primary pay-all">
              {finesSettings.get('text') ? finesSettings.get('text') : `${this.props.intl.formatMessage({ id: 'pay_all' })} `}
              {!finesSettings.get('text') ? <DollarAmount amount={this.props.summary.get('totalFines', 0)} /> : ''}
            </Link>
            }
          {finesSettings.get('url2') &&
            <Link to={this.getUrlWithPatronInfo(finesSettings.get('url2'))} target={popup ? '_blank' : '_self'} className="btn cp-primary-btn btn-secondary pay-all">
              {finesSettings.get('text2')}
            </Link>
            }
          {finesSettings.get('type') &&
            <PrimaryButton handleClick={this.payAll} className="pay-all">
              {this.props.intl.formatMessage({ id: 'pay_all' })} <DollarAmount amount={this.props.summary.get('totalFines', 0)} />
            </PrimaryButton>
            }
        </div>
        <div
          className="payflow_invisible_form"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={this.createMarkup()} />
      </div>
    );
  }

  getSortOptions() {
    const currentSort = this.props.router.location.query.sort || 'messageDate';
    return ['messageDate', 'bibTitle', 'amount', 'description'].reduce(
      (acc, val) =>
        acc.set(
          val,
          Immutable.Map({
            id: val,
            applied: val === currentSort
          })
        ),
      Immutable.Map()
    ).toList();
  }

  handleSort(sortType) {
    const { location, router } = this.props;
    router.push({
      ...location,
      query: {
        ...location.query,
        page: this.props.router.location.query.page,
        sort: sortType
      }
    });
    this.props.FinesActions.updatePage({
      ...location.query,
      page: this.props.router.location.query.page,
      sort: sortType,
      accountId: this.props.account.get('id')
    });
  }


  updatePage(page, sort = 'messageDate') {
    const { location, router } = this.props;
    router.push({
      ...location,
      query: {
        ...location.query,
        page,
        sort
      }
    });
    this.props.FinesActions.updatePage({
      ...location.query,
      page,
      sort,
      accountId: this.props.account.get('id')
    });
  }

  refreshTable() {
    this.updatePage(1);
  }

  getPagination() {
    const { currentPage, pageSize, totalItems, totalPages } = this.props;
    return Immutable.Map({
      page: currentPage,
      limit: pageSize,
      count: totalItems,
      pages: totalPages
    });
  }

  updateAll() {
    this.setState({
      selectedItems: Immutable.Map()
    });
  }

  renderBatchActionsToolbar() {
    return (
      <BatchActionsToolbar
        actionIsLoading={this.props.isFetching}
        handleClear={() => this.updateAll(false)}
        renderActionsMenu={this.renderBatchActionsMenu}
        totalItems={this.props.totalItems}
        messagingActions={this.props.messagingActions}
        selectedItems={this.state.selectedItems} />
    );
  }

  getSelectedTotal() {
    let finesTotal = 0;
    this.props.fines.forEach((fine) => {
      this.state.selectedItems.keySeq().forEach((v) => {
        if (fine.get('id') === v) {
          if (fineIsPayable(fine)) {
            finesTotal += fine.get('amount');
          }
        }
      });
    });

    return finesTotal;
  }

  renderBatchActionsMenu(selectedActionItems) {
    return [
      <DropdownMenuItem key="fines-batch-actions-pay">
        <BatchActionLink
          disabled={selectedActionItems.size === 0}
          href="#fines-batch-actions-pay"
          handleClick={this.paySelected}>
          <FormattedMessage id="pay_selected" />&nbsp;
          (<DollarAmount amount={this.getSelectedTotal()} />)
        </BatchActionLink>
      </DropdownMenuItem>
    ];
  }

  formatFines() {
    const indiviualFinePayment = this.props.onlineFinesPayment ? this.props.onlineFinesPayment.get('individual_fine_payment') : false;
    let formattedFines = this.props.fines.map((fine) => {
      let newFine = fine;

      if (!fine.get('description') && fine.get('message')) {
        newFine = newFine.set('description', fine.get('message'));
      }

      return newFine;
    }).toList();

    formattedFines = formattedFines.map((row) => {
      let newRow = row;
      this.state.selectedItems.keySeq().forEach((v) => {
        if (row.get('id') === v) {
          newRow = row.set('selected', true);
        }
      });
      if (!indiviualFinePayment) {
        newRow = newRow.delete('id');
      }
      return newRow;
    });

    return formattedFines;
  }

  renderContent() {
    const { fines, onlineFinesPayment, isFetching } = this.props;
    const payableFines = fines.size > 0 ? fines.filter(fineIsPayable) : 0;

    const indiviualFinePayment = onlineFinesPayment ? onlineFinesPayment.get('individual_fine_payment') : false;
    const finePaymentAllowed = onlineFinesPayment && payableFines.size > 0;

    if (fines.size === 0) {
      return <FinesEmptyContentPanel fetching={isFetching} />;
    }

    const fields = [
      { key: 'id', type: 'id', headerKey:'table_headings_item_select', transformationMap: this.renderFinesCheckbox, leftAlignedCheckbox: true },
      { key: 'messageDate', id:'facets_fine_date', headerKey:'facets_fine_date', type: 'Date', noWrap: true },
      { key: 'bibTitle',
        headerKey:'facets_message',
        type: 'String',
        transformationMap: (value, index, row) => {
          let bibTitle = '';
          let subTitle = '';
          if (row.has('bibSubtitle') && row.get('bibSubtitle') !== null && row.get('bibSubtitle').length > 0) {
            subTitle = ` - ${row.get('bibSubtitle')}`;
          }
          if (row.get('metadataId')) {
            bibTitle = (
              <span>
                <a href={`/item/show/${metadataIdFixer(row.get('metadataId'))}`} title={row.get('bibTitle')}>
                  {row.get('bibTitle')}
                </a>
                {subTitle}
              </span>
            );
          } else {
            bibTitle = `${row.get('bibTitle')}${subTitle}`;
          }

          return (
            <div>
              <div>{bibTitle}</div>
              <FineDateFields fine={row} />
            </div>
          );
        }
      },
      {
        key: 'description',
        headerKey: 'facets_fine_reason',
        type: 'string',
        transformationMap: (value, index, row) => {
          let reason = '';
          if (row.has('message') && row.get('message').length > 0
            && row.has('description') && row.get('description').length > 0) {
            reason = `${row.get('description')} - ${row.get('message')}`;
          } else {
            reason = `${row.get('description')}${row.get('message')}`;
          }
          return reason;
        }
      },
      { key: 'amount', headerKey:'facets_amount', transformationMap: renderAmountAndStatus, rightAlign: true }
    ];

    if (!indiviualFinePayment) {
      fields.unshift({ key: 'id', type: 'id', headerKey:'table_headings_item_select', transformationMap: this.renderFinesCheckbox });
    }

    const emptyMessageOptions = Immutable.Map({
      type: 'Failure',
      id: 'error_no_fines_selected'
    });

    const pagination = this.getPagination();
    return (
      <div>
        {this.state.showEmptyFineError && <Generic message={emptyMessageOptions} failureDuration={3000} clearMessages={() => this.setState({ showEmptyFineError: false })} />}
        <MessagingContainer id="finesNotice">
          {(messageOptions) => <Generic {...messageOptions} />}
        </MessagingContainer>
        <div className="title-row">
          <BorrowingHeader
            headingKey="section_title_fines"
            taglineKey="section_tagline_fines"
            helpLinkPage="005borrowing/010fines" />
          <BorrowingList>
            <FinesUtilityBar
              isFetching={this.props.isFetching}
              sortOptions={this.getSortOptions()}
              summary={this.props.summary}
              handleRefresh={this.refreshTable}
              pagination={pagination}
              onlineFinesPayment={onlineFinesPayment}
              home="/v2/fines" />
            {finePaymentAllowed && indiviualFinePayment &&
            <BatchActionsControls
              list={payableFines.map(fine => fine.get('id'))}
              totalItems={payableFines}
              selectedItems={this.state.selectedItems}
              updateAll={this.selectAll}>
              {this.renderFinesPaymentButtons()}
            </BatchActionsControls>
            }
            {finePaymentAllowed && !indiviualFinePayment &&
              <div className="cp-fines-control">
                {this.renderFinesPaymentButtons()}
              </div>
            }
            {fines.size > 0 &&
              <div className={cn('cp-fines-table', { 'without-payment': !finePaymentAllowed })}>
                <Table
                  rows={this.formatFines()}
                  fields={fields}
                  selectedRows={this.state.selectedItems}
                  className="fines-table"
                  hasLeftAlignedCheckbox={indiviualFinePayment} />
              </div>
            }
            {finePaymentAllowed ? this.renderBatchActionsToolbar() : ''}
          </BorrowingList>
          {fines.size > 0 &&
          <Pagination
            isFetching={this.props.isFetching}
            page={pagination.get('page')}
            limit={pagination.get('limit')}
            count={pagination.get('count')}
            pages={pagination.get('pages')}
            className="cp-pagination-bottom"
            showPages />
          }
        </div>
      </div>
    );
  }

  render() {
    const { isFetching } = this.props;
    return (
      <div className="cp-fines">
        <ProgressBar active={isFetching} />
        {this.renderContent()}
      </div>
    );
  }
}

Fines.propTypes = {
  user: ImmutablePropTypes.map,
  account: ImmutablePropTypes.map,
  fines: ImmutablePropTypes.map.isRequired,
  finesIDs: ImmutablePropTypes.list.isRequired,
  summary: ImmutablePropTypes.map.isRequired,
  paymentForm: React.PropTypes.string,
  FinesActions: PropTypes.objectOf(PropTypes.func),
  totalItems: React.PropTypes.number.isRequired,
  totalPages: React.PropTypes.number.isRequired,
  pageSize: React.PropTypes.number.isRequired,
  currentPage: React.PropTypes.number.isRequired,
  isFetching: React.PropTypes.bool,
  onlineFinesPayment: ImmutablePropTypes.map,
  messagingActions: PropTypes.objectOf(PropTypes.func),
  intl: intlShape.isRequired
};


export default injectIntl(withRouter(Fines));



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/Fines/Fines.jsx